import { loggedInSelector } from '../spa/selectors/users'
import { LOGIN_MODAL, openModal } from 'spa/action_creators/modals'
import { MaintenanceDisplay } from '../spa/pages/maintenance'
import { maintenanceSelector } from '../spa/selectors/maintenance'
import { AVAILABLE_FEATURES, isFeatureEnabled } from '../spa/selectors/features'
import { MarketingDisplay } from '../spa/pages/marketing'
import { Route, useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import React from 'react'

export const ApplicationRoute = ({ requireAuth = false, ...rest }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { pathname, search } = useLocation()
  const isLoggedIn = useSelector(loggedInSelector)
  const maintenanceMode = useSelector(maintenanceSelector)

  const sunsetFeatureStatus = useSelector(state =>
    isFeatureEnabled(state.features, AVAILABLE_FEATURES.SUNSET_MODE)
  )
  const sunsetModeStatus = useSelector(state => state.sunset.sunsetModeStatus)
  const isSunsetOn = isLoggedIn ? sunsetFeatureStatus : sunsetModeStatus

  if (maintenanceMode) {
    return <MaintenanceDisplay />
  }

  if (isSunsetOn && pathname !== '/beatport') {
    history.replace('/beatport' + search)
    return null
  } else if (!isSunsetOn && pathname === '/beatport') {
    isLoggedIn ? history.replace('/home' + search) : history.replace('/')
    return null
  }

  if (!isLoggedIn && requireAuth) {
    dispatch(openModal(LOGIN_MODAL))
    return <MarketingDisplay />
  }
  return <Route {...rest} />
}

ApplicationRoute.propTypes = {
  requireAuth: PropTypes.bool,
}
